// src/lib/blog/utils/listingImage.ts

import type { BlogPost } from '~/lib/blog/types'
import { DEFAULT_IMAGE } from '~/lib/blog/config'

/**
 * Image URL for blog cards and homepage grids. Prefers the editorial hero so
 * listings match the article hero; falls back to preview then OG.
 *
 * @param post - Blog post with `images.hero`, `images.preview`, and `images.og`.
 * @returns {string} Absolute path or URL to the listing image.
 */
export function getBlogListingImageUrl(post: BlogPost): string {
  return post.images.hero.url ?? post.images.preview.url ?? post.images.og.url ?? DEFAULT_IMAGE
}

/**
 * Alt text aligned with {@link getBlogListingImageUrl}.
 *
 * @param post - Blog post.
 * @returns {string} Alt string for the listing image.
 */
export function getBlogListingImageAlt(post: BlogPost): string {
  return post.images.hero.alt ?? post.images.preview.alt ?? post.images.og.alt ?? post.title
}
